import { FC, MouseEvent, ReactNode } from 'react';

import { Text, TextTypography } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';

import { MobileTooltipBottomSheet } from 'components/CampaignsDashboard/components/CampaignsTable/components/MobileTooltipBottomSheet';

import styles from 'components/CampaignsDashboard/components/CampaignsTable/components/MobileEllipsisText.module.less';

interface MobileEllipsisTextProps {
    children: ReactNode;
    bottomSheetContent?: ReactNode;
    bottomSheetTitle: ReactNode;
    typography: TextTypography;
    dataQa: string;
}

export const MobileEllipsisText: FC<MobileEllipsisTextProps> = ({
    children,
    bottomSheetContent = children,
    bottomSheetTitle,
    typography,
    dataQa,
}) => {
    const [isBottomSheetVisible, setIsBottomSheetVisibleOn, setIsBottomSheetVisibleOff] = useOnOffState(false);

    const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        const textElement = event.currentTarget.firstElementChild;

        if (textElement instanceof HTMLElement && textElement.scrollWidth > textElement.clientWidth) {
            setIsBottomSheetVisibleOn();
        }
    };

    return (
        <>
            <div className={styles.activator} onClick={handleClick} data-qa={`${dataQa}-activator`}>
                <Text ellipsis typography={typography}>
                    {children}
                </Text>
            </div>
            <MobileTooltipBottomSheet
                visible={isBottomSheetVisible}
                onClose={setIsBottomSheetVisibleOff}
                title={bottomSheetTitle}
                dataQa={`${dataQa}-bottom-sheet`}
            >
                {bottomSheetContent}
            </MobileTooltipBottomSheet>
        </>
    );
};
